import { store } from 'OMFECore/store';
import { configConst, setConfig } from 'OMFECore/config-manager';
import { storageConst, saveLocalItem } from 'OMFECore/storage';

import { moment, userTimezone } from 'OMFECore/vendors';

/**
 * Constants
 */
export const timezoneSelectorConst = {
    STORE_PART: 'omfe:omfetimezoneselector:timezone',
    supportedTimezones: moment.tz.names(),
};

/**
 * setTimezone - set system timezone
 */
export function setTimezone(timezone = '') {
    if (!timezone) {
        return { type: `NONE ${Date.now()}` };
    }
    return store.dispatch(setConfig({ timezone }));
}

/**
 * Retrieve an Apply Timezone from localStorage
 */
const currentState = store.getState()[storageConst.STORE_PART];
if (currentState && currentState[timezoneSelectorConst.STORE_PART]) {
    store.dispatch(setTimezone(currentState[timezoneSelectorConst.STORE_PART]));
}

/**
 * React to Configuration Changes
 */
let currentTimezone = '';
store.subscribe(() => {
    const state = store.getState()[configConst.STORE_PART];
    if (state && state.timezone && state.timezone !== currentTimezone) {
        currentTimezone = state.timezone;
        saveLocalItem(timezoneSelectorConst.STORE_PART, state.timezone);
    }
});


/**
 * Set Default Timezone on Load
 */
//
if (!currentTimezone || !currentTimezone.length) {
    store.dispatch(setTimezone(userTimezone));
}



// WEBPACK FOOTER //
// ./src/OMFESelectors/services/timezoneselector.js